import React from 'react';
import { Row } from 'react-table';
import { PortfolioAssetsType } from 'services/requests';
import Table from 'components/Table';
import {
  AssetsColumnsType,
  MapData,
  PortfolioAssetsTableSign,
  getColumns,
} from '../../UserAssetsTable.columns';

type Props = {
  columns: AssetsColumnsType[];
  assetsListData?: PortfolioAssetsType;
  items?: MapData;
  onAssetClick: (row: Row<PortfolioAssetsTableSign>) => void;
};

const RenderAssetsTable: React.FC<Props> = ({
  columns,
  assetsListData,
  items,
  onAssetClick,
}) => {
  if (!assetsListData || !items || (items && items?.length === 0)) return null;

  return (
    <Table<PortfolioAssetsTableSign>
      columns={getColumns(columns)}
      data={items}
      onRowClick={onAssetClick}
    />
  );
};

export default RenderAssetsTable;
